import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { EditorModule } from '@tinymce/tinymce-angular';
import { StripHtmlPipe } from "./_helpers/strip-html-pipe";
// import { DataTableModule } from 'ng-angular8-datatable';

import { DataTablesModule } from 'angular-datatables';
import {NgxPaginationModule} from 'ngx-pagination';

import { Ng2ImgMaxModule } from 'ng2-img-max';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { DpDatePickerModule } from 'ng2-date-picker';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FullCalendarModule } from '@fullcalendar/angular'; // for FullCalendar!

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/layouts/header/header.component';
import { SidebarComponent } from './components/layouts/sidebar/sidebar.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';

import { AuthGuard } from './_helpers/auth.guard';
import { AuthenicationService } from './_services/authenication.service';
import { TokenInterceptor } from './_helpers/token-interceptor';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { ShowoverallComponent } from './components/dashboard/showoverall/showoverall.component';
import { LinechartComponent } from './components/dashboard/linechart/linechart.component';
import { MinicalenderComponent } from './components/dashboard/minicalender/minicalender.component';
import { BarchartComponent } from './components/dashboard/barchart/barchart.component';
import { RanderchartComponent } from './components/dashboard/randerchart/randerchart.component';
import { BasicdatamapComponent } from './components/dashboard/basicdatamap/basicdatamap.component';
import { DatatablesComponent } from './components/dashboard/datatables/datatables.component';
import { AdddoctorComponent } from './components/adddoctor/adddoctor.component';
import { DoctorslistComponent } from './components/doctorslist/doctorslist.component';
import { UserprofileComponent } from './components/userprofile/userprofile.component';
import { AdminComponent } from './components/userprofile/admin/admin.component';
import { DoctorComponent } from './components/userprofile/doctor/doctor.component';
import { UserComponent } from './components/userprofile/user/user.component';
import { AdmincssComponent } from './components/layouts/admincss/admincss.component';
import { AdminjsComponent } from './components/layouts/adminjs/adminjs.component';
import { AddpatientComponent } from './components/addpatient/addpatient.component';
import { PatientlistComponent } from './components/patientlist/patientlist.component';
import { DoctorappointmentsComponent } from './components/doctorappointments/doctorappointments.component';
import { PatientappointmentsComponent } from './components/patientappointments/patientappointments.component';
import { PatientplansComponent } from './components/patient-plan/patientplans.component';
import { CategoriesComponent } from './components/psychometrictests/categories/categories.component';
import { AddCategoryComponent } from './components/psychometrictests/add-category/add-category.component';
import { AddTestComponent } from './components/psychometrictests/add-test/add-test.component';
import { TestlistComponent } from './components/psychometrictests/testlist/testlist.component';
import { UsertestlistComponent } from './components/usertestlist/usertestlist.component';
import { SingletestresultComponent } from './components/singletestresult/singletestresult.component';
import { WalllistComponent } from './components/walllist/walllist.component';
import { WalllcategoriesComponent } from './components/walllcategories/walllcategories.component';
import { AddwallcategoryComponent } from './components/addwallcategory/addwallcategory.component';
import { ScheduleComponent } from './components/schedule/schedule.component';
import { DoctorAppointmentsComponent } from './components/doctor-appointments/doctor-appointments.component';
import { SinglepatientappointmentComponent } from './components/singlepatientappointment/singlepatientappointment.component';
import { PatientsearchComponent } from './components/patientsearch/patientsearch.component';
import { AddNotesComponent } from './components/add-notes/add-notes.component';
import { ViewNotesComponent } from './components/view-notes/view-notes.component';
import { ForgotpasswordComponent } from './components/forgotpassword/forgotpassword.component';
import { ResetpasswordComponent } from './components/resetpassword/resetpassword.component';
import { AddQuoteComponent } from './components/add-quote/add-quote.component';
import { GetQuotesComponent } from './components/get-quotes/get-quotes.component';
import { AddReviewComponent } from './components/add-review/add-review.component';
import { GetReviewComponent } from './components/get-review/get-review.component';
import { GetContactsComponent } from './components/get-contacts/get-contacts.component';
import { ChangepasswordComponent } from './components/changepassword/changepassword.component';
import { DocDetailComponent } from './components/doc-detail/doc-detail.component';
import { AddemailsComponent } from './components/addemails/addemails.component';
import { EmaillistComponent } from './components/emaillist/emaillist.component';
import { RescheduleComponent } from './components/reschedule/reschedule.component';
import { AddEventComponent } from './components/add-event/add-event.component';
import { EventslistComponent } from './components/eventslist/eventslist.component';
import { AppointmentDetailComponent } from './components/appointment-detail/appointment-detail.component';
import { EventbookingsComponent } from './components/eventbookings/eventbookings.component';
import { EventbookingsdetailComponent } from './components/eventbookingsdetail/eventbookingsdetail.component';
import { EditEventComponent } from './components/edit-event/edit-event.component';
import { AddPriceComponent } from './components/add-price/add-price.component';
import { PricelistComponent } from './components/pricelist/pricelist.component';
import { EditPriceComponent } from './components/edit-price/edit-price.component';
import { SubscriptionsComponent } from './components/subscriptions/subscriptions.component';
import { AddPromocodeComponent } from './components/add-promocode/add-promocode.component';
import { PromocodelistComponent } from './components/promocodelist/promocodelist.component';
import { EditCategoryComponent } from './components/psychometrictests/edit-category/edit-category.component';
import { EditTestComponent } from './components/psychometrictests/edit-test/edit-test.component';
import { AddSliderComponent } from './components/add-slider/add-slider.component';
import { SliderslistComponent } from './components/sliderslist/sliderslist.component';
import { AddCmsComponent } from './components/add-cms/add-cms.component';
import { EditCmsComponent } from './components/edit-cms/edit-cms.component';
import { ListCmsComponent } from './components/list-cms/list-cms.component';
import { AppointmentsComponent } from './components/appointments/appointments.component';
import { EditProfileComponent } from './components/edit-profile/edit-profile.component';
import { AddTestimonialComponent } from './components/add-testimonial/add-testimonial.component';
import { EditTestimonialComponent } from './components/edit-testimonial/edit-testimonial.component';
import { TestimonialsComponent } from './components/testimonials/testimonials.component';
import { UserCrmPointsComponent } from './components/user-crm-points/user-crm-points.component';
import { AddUserCrmPointsComponent } from './components/add-user-crm-points/add-user-crm-points.component';
import { EditUserCrmPointsComponent } from './components/edit-user-crm-points/edit-user-crm-points.component';
import { ScheduleListComponent } from './components/schedule-list/schedule-list.component';
import { UpdatePasswordComponent } from './components/update-password/update-password.component';
import { CustomerslistComponent } from './components/customerslist/customerslist.component';
import { AlleventbookinglistComponent } from './components/alleventbookinglist/alleventbookinglist.component';
import { AddWallReplyComponent } from './components/add-wall-reply/add-wall-reply.component';
import { AddWallComponent } from './components/add-wall/add-wall.component';
import { GetWallReplyComponent } from './components/get-wall-reply/get-wall-reply.component';
import { EnquiryListComponent } from './components/enquiry-list/enquiry-list.component';
import { LetterUsersComponent } from './components/letter-users/letter-users.component';
import { LetterMessagesComponent } from './components/letter-messages/letter-messages.component';
import { SchoolEnquiryListComponent } from './components/school-enquiry-list/school-enquiry-list.component';
import { CompanyEnquiryListComponent } from './components/company-enquiry-list/company-enquiry-list.component';
import { BookAppointmentComponent } from './components/book-appointment/book-appointment.component';
import { ScheduleTestComponent } from './components/schedule-test/schedule-test.component';
import { WishlistComponent } from './components/wishlist/wishlist.component';
import { PandemicCareComponent } from './components/pandemic-care/pandemic-care.component';
import { PandemicCareDownloadComponent } from './components/pandemic-care-download/pandemic-care-download.component';
import { CreatePaymentLinkComponent } from './components/create-payment-link/create-payment-link.component';
import {NgDatepickerModule} from "ng2-datepicker";
// import { WkComponent } from './components/wk/wk.component';
// import { UandlComponent } from './components/uandl/uandl.component';
import { AppliedMhpComponent } from './components/applied-mhp/applied-mhp.component';
import { WatconsultComponent } from './components/watconsult/watconsult.component';
import { AddGstComponent } from './components/add-gst/add-gst.component';
import { GetGstComponent } from './components/get-gst/get-gst.component';
import { NomineelistComponent } from './components/nomineelist/nomineelist.component';
import { AddScheduleFromExcelComponent } from './components/add-schedule-from-excel/add-schedule-from-excel.component';
import { TransferPatientComponent } from './components/transfer-patient/transfer-patient.component';
import { TransferListComponent } from './components/transfer-list/transfer-list.component';
import { AddOrganizationUrlComponent } from './components/add-organization-url/add-organization-url.component';
import { OrganizationUrlComponent } from './components/organization-url/organization-url.component';
import { AddEmailTypeComponent } from './components/add-email-type/add-email-type.component';
import { EditEmailTypeComponent } from './components/edit-email-type/edit-email-type.component';
import { EmailTypeListComponent } from './components/email-type-list/email-type-list.component';
import { TatamotorsComponent } from './components/tatamotors/tatamotors.component';
import { GiftsessionlistComponent } from './components/giftsessionlist/giftsessionlist.component';
import { OtpGenerationComponent } from './components/otp-generation/otp-generation.component';
import { OtpListComponent } from './components/otp-list/otp-list.component';
import { CreateApiKeysComponent } from './components/create-api-keys/create-api-keys.component';
import { ApiKeysListComponent } from './components/api-keys-list/api-keys-list.component';
import { EapAppointmentsComponent } from './components/eap-appointments/eap-appointments.component';
import { EapUsersComponent } from './components/eap-users/eap-users.component';
import { CompanyEnquiryListv2Component } from './components/company-enquiry-list-v2/company-enquiry-list-v2.component';
import { GetRecommendationValuesComponent } from './components/get-recommendation-values/get-recommendation-values.component';
import { AddQuoteContentComponent } from './components/add-quote-content/add-quote-content.component';
import { GetQuoteContentComponent } from './components/get-quote-content/get-quote-content.component';
import { AddCouponcodeComponent } from './components/add-couponcode/add-couponcode.component';
import { CouponcodelistComponent } from './components/couponcodelist/couponcodelist.component';
import { GiftCodelistComponent } from './components/gift-codelist/gift-codelist.component';
import { AddOrganisationComponent } from './components/add-organisation/add-organisation.component';
import { OrganisationListComponent } from './components/organisation-list/organisation-list.component';
import { AddPlanComponent } from './components/add-plan/add-plan.component';
import { PlanlistComponent } from './components/planlist/planlist.component';
import { AddMeetingDetailsComponent } from './components/add-meeting-details/add-meeting-details.component';
import { MeetingDetailsComponent } from './components/meeting-details/meeting-details.component';




// @ts-ignore
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    DashboardComponent,
    LoginComponent,
    FooterComponent,
    ShowoverallComponent,
    LinechartComponent,
    MinicalenderComponent,
    BarchartComponent,
    RanderchartComponent,
    BasicdatamapComponent,
    DatatablesComponent,
    AdddoctorComponent,
    DoctorslistComponent,
    UserprofileComponent,
    AdminComponent,
    DoctorComponent,
    UserComponent,
    AdmincssComponent,
    AdminjsComponent,
    AddpatientComponent,
    PatientlistComponent,
    DoctorappointmentsComponent,
    PatientappointmentsComponent,
    PatientplansComponent,
    CategoriesComponent,
    AddCategoryComponent,
    AddTestComponent,
    TestlistComponent,
    UsertestlistComponent,
    SingletestresultComponent,
    WalllistComponent,
    WalllcategoriesComponent,
    AddwallcategoryComponent,
    ScheduleComponent,
    DoctorAppointmentsComponent,
    SinglepatientappointmentComponent,
    PatientsearchComponent,
    AddNotesComponent,
    ViewNotesComponent,
    RegisterComponent,
    ForgotpasswordComponent,
    ResetpasswordComponent,
    AddQuoteComponent,
    GetQuotesComponent,
    AddReviewComponent,
    GetReviewComponent,
    GetContactsComponent,
    ChangepasswordComponent,
    DocDetailComponent,
    AddemailsComponent,
    EmaillistComponent,
    RescheduleComponent,
    AddEventComponent,
    EventslistComponent,
    AppointmentDetailComponent,
    EventbookingsComponent,
    EventbookingsdetailComponent,
    EditEventComponent,
    AddPriceComponent,
    PricelistComponent,
    EditPriceComponent,
    SubscriptionsComponent,
    AddPromocodeComponent,
    PromocodelistComponent,
    EditCategoryComponent,
    EditTestComponent,
    StripHtmlPipe,
    AddSliderComponent,
    SliderslistComponent,
    AddCmsComponent,
    EditCmsComponent,
    ListCmsComponent,
    AppointmentsComponent,
    EditProfileComponent,
    AddTestimonialComponent,
    EditTestimonialComponent,
    TestimonialsComponent,
    UserCrmPointsComponent,
    AddUserCrmPointsComponent,
    EditUserCrmPointsComponent,
    ScheduleListComponent,
    UpdatePasswordComponent,
    CustomerslistComponent,
    AlleventbookinglistComponent,
    AddWallReplyComponent,
    AddWallComponent,
    GetWallReplyComponent,
    EnquiryListComponent,
    LetterUsersComponent,
    LetterMessagesComponent,
    SchoolEnquiryListComponent,
    CompanyEnquiryListComponent,
    CompanyEnquiryListv2Component,
    BookAppointmentComponent,
    ScheduleTestComponent,
    WishlistComponent,
    PandemicCareComponent,
    PandemicCareDownloadComponent,
    CreatePaymentLinkComponent,
    // WkComponent,
    // UandlComponent,
    AppliedMhpComponent,
    WatconsultComponent,
    AddGstComponent,
    GetGstComponent,
    NomineelistComponent,
    AddScheduleFromExcelComponent,
    TransferPatientComponent,
    TransferListComponent,
    AddOrganizationUrlComponent,
    OrganizationUrlComponent,
    AddEmailTypeComponent,
    EditEmailTypeComponent,
    EmailTypeListComponent,
    TatamotorsComponent,
    GiftsessionlistComponent,
    OtpGenerationComponent,
    OtpListComponent,
    CreateApiKeysComponent,
    ApiKeysListComponent,
    EapAppointmentsComponent,
    EapUsersComponent,
    GetRecommendationValuesComponent,
    AddQuoteContentComponent,
    GetQuoteContentComponent,
    AddCouponcodeComponent,
    CouponcodelistComponent,
    GiftCodelistComponent,
    AddOrganisationComponent,
    OrganisationListComponent,
    AddPlanComponent,
    PlanlistComponent,
    AddMeetingDetailsComponent,
    MeetingDetailsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    DpDatePickerModule,
    Ng2ImgMaxModule,
    // DataTableModule,
    DataTablesModule,
    EditorModule,
    FullCalendarModule,
    Ng4LoadingSpinnerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot({
      timeOut: 2000
    }),
    NgDatepickerModule,
    NgxPaginationModule
    // ToastrModule added
  ],
  providers: [
    AuthGuard,
    AuthenicationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
